//BRANCH IMPORTS
import SYA0200 from "../pages/systemAdmin/Branch/BranchSummary";
import AddSYA0200 from "../pages/systemAdmin/Branch/CreateBranch";
import ViewSYA0200 from "../pages/systemAdmin/Branch/ViewBranch";
import EditSYA0200 from "../pages/systemAdmin/Branch/EditBranch";
import ImportSYA0200 from "../pages/systemAdmin/Branch/ImportBranch";

//BRANCH TYPES IMPORTS
import SYA0300 from "../pages/systemAdmin/branchTypes/ManageBranchTypes";
import AddSYA0300 from "../pages/systemAdmin/branchTypes/AddBranchTypes";
import EditSYA0300 from "../pages/systemAdmin/branchTypes/EditBranchTypes";
import ViewSYA0300 from "../pages/systemAdmin/branchTypes/ViewBranchTypes";

//BRANCH CONFIGURATION IMPORTS
import ManageBranchConfiguration from "../pages/systemAdmin/branchConfiguration/ManageBranchConfiguration";
import NewBranchConfiguration from "../pages/systemAdmin/branchConfiguration/NewBranchConfiguration";
import EditBranchConfiguration from "../pages/systemAdmin/branchConfiguration/EditBranchConfiguratioin";
import DetailBranchConfiguration from "../pages/systemAdmin/branchConfiguration/DetailBranchConfiguration";


//BRANCH VAULT SETUP IMPORTS
import ManageBranchVault from "../pages/systemAdmin/branchVault/ManageBranchVault";
import NewSYA0500 from "../pages/systemAdmin/branchVault/NewBranchVault";
import DetailVaultConfig from "../pages/systemAdmin/branchVault/DetailVaultConfig";
import EditVaultConfiguration from "../pages/systemAdmin/branchVault/EditBranchVault";

//TILL CONFIGURATION IMPORTS
import ManageTillConfiguration from "../pages/systemAdmin/tillConfiguration/ManageTillConfiguration";
import NewTillConfiguration from "../pages/systemAdmin/tillConfiguration/NewTillConfiguration";
import EditTillConfiguration from "../pages/systemAdmin/tillConfiguration/EditTillConfiguratioin";
import DetailTillConfiguration from "../pages/systemAdmin/tillConfiguration/DetailTillConfiguration";


//HOLIDAY IMPORTS
import SYA0700 from "../pages/systemAdmin/holidays/Holidays";
import AddSYA0700 from "../pages/systemAdmin/holidays/AddHolidays";
import ViewSYA0700 from "../pages/systemAdmin/holidays/ViewHolidays";
import EditSYA0700 from "../pages/systemAdmin/holidays/EditHolidays";

//ENTITY TABLES IMPORTS
import SYA0900 from "../pages/systemAdmin/entityTable/SummaryEntityTable";
import AddSYA0900 from "../pages/systemAdmin/entityTable/AddEntityTable";

//WORKDAYS IMPORT
import SYA0800 from "../pages/systemAdmin/workdays/Workdays";

//PAYMENT TYPES IMPORTS
import SYA1100 from "../pages/systemAdmin/paymentType/summaryPaymentType";
import EditSYA1100 from "../pages/systemAdmin/paymentType/EditPaymentType";

//USER DEFINED TABLE IMPORTS
import SYA1000 from "../pages/systemAdmin/dataTable/DataTable";
import AddSYA1000 from "../pages/systemAdmin/dataTable/AddDataTable";
import ViewSYA1000 from "../pages/systemAdmin/dataTable/ViewDataTable";
import EditSYA1000 from "../pages/systemAdmin/dataTable/EditDataTable";

//CURRENCY IMPORTS
import SYA1300 from "../pages/systemAdmin/currency/summaryCurrency";
import AddSYA1300 from "../pages/systemAdmin/currency/addCurrency";
import ViewSYA1300 from "../pages/systemAdmin/currency/viewCurrency";

//CODE DEFINITION IMPORTS
import SYA1200 from "../pages/systemAdmin/codeDefinition/CodeDefinition";
import AddSYA1200 from "../pages/systemAdmin/codeDefinition/AddCodeDefinition";
import ViewSYA1200 from "../pages/systemAdmin/codeDefinition/ViewCodeDefinition";
import EditSYA1200 from "../pages/systemAdmin/codeDefinition/EditCodeDefinition";

//SMS CAMPAIGN IMPORTS
import SYA1400 from "../pages/systemAdmin/smsCampaign/SummarySMSCampaign";
import AddSYA1400 from "../pages/systemAdmin/smsCampaign/AddSMSCampaign";

//SYSTEM HOOK IMPORTS
import SYA1500 from "../pages/systemAdmin/systemHook/SystemHook";
import AddSYA1500 from "../pages/systemAdmin/systemHook/AddSystemHook";
import ViewSYA1500 from "../pages/systemAdmin/systemHook/ViewSystemHook";

//BULK IMPORT IMPORT
import SYA1600 from "../pages/systemAdmin/bulkImport/BulkImport";

//ENTITY MAPPING IMPORT
import SYA1700 from "../pages/systemAdmin/entityMapping/EntityMapping";

//GLOBAL CONFIGURATION IMPORTS
import SYA2100 from "../pages/systemAdmin/globalConfiguration/GlobalConfig";
import EditSYA2100 from "../pages/systemAdmin/globalConfiguration/EditGlobalConfig";

//CUSTOMER SURVEY IMPORTS
import SYA1800 from "../pages/systemAdmin/customerSurvey/SummaryCustomerSurvey";
import AddSYA1800 from "../pages/systemAdmin/customerSurvey/AddCustomerSurvey";
import ViewSYA1800 from "../pages/systemAdmin/customerSurvey/ViewCustomerSurvey";
import EditSYA1800 from "../pages/systemAdmin/customerSurvey/EditCustomerSurvey";

//ADHOC QUERY SETUP IMPORTS
import SYA2200 from "../pages/systemAdmin/adhocQuerySetup/SummaryAdhocQuery";
import AddSYA2200 from "../pages/systemAdmin/adhocQuerySetup/AddAdhocQuery";
import ViewSYA2200 from "../pages/systemAdmin/adhocQuerySetup/ViewAdhocQuery";
import EditSYA2200 from "../pages/systemAdmin/adhocQuerySetup/EditAdhocQuery";

//BATCH JOB OPERATIONS IMPORTS
import SYA2300 from "../pages/systemAdmin/batchJobOperations/SummaryBatchJobOperations";
import ViewSYA2300 from "../pages/systemAdmin/batchJobOperations/ViewBatchJobOperations";
import EditSYA2300 from "../pages/systemAdmin/batchJobOperations/EditBatchJobOperations";
import AddSYA2300 from "../pages/systemAdmin/batchJobOperations/AddBatchJobOperations";

//BULK LOAN REASSIGNMENT IMPORT
import SYA2400 from "../pages/systemAdmin/bulkLoanReassignment/BulkLoanReass";

//CLIENT CATEGORY IMPORTS
import SYA2500 from "../pages/systemAdmin/clientCategory/SummaryClientCategory";
import AddSYA2500 from "../pages/systemAdmin/clientCategory/AddClientCategory";
import ViewSYA2500 from "../pages/systemAdmin/clientCategory/ViewClientCategory";
import EditSYA2500 from "../pages/systemAdmin/clientCategory/EditClientCategory";

//LIMIT RULE MAKER IMPORT
import SYA2600 from "../pages/systemAdmin/limitRuleMaker/LimitRuleMaker";

//ACCOUNT NUMBERING IMPORTS
import SYA0100 from "../pages/systemAdmin/accountNumbering/AccountNumberingSummary";
import AddSYA0100 from "../pages/systemAdmin/accountNumbering/AddPreferences";
import ViewSYA0100 from "../pages/systemAdmin/accountNumbering/ViewPreferences";
import EditSYA0100 from "../pages/systemAdmin/accountNumbering/EditPreferences";
import ManageBranch from "../pages/systemAdmin/Branch/ManageBranch";

// NOTIFICATION SETUP
import ViewEmailService from "../pages/systemAdmin/emailService/ViewEmailService";
import EditEmailService from "../pages/systemAdmin/emailService/EditEmailService";
import ViewSmtpService from "../pages/systemAdmin/smtpService/ViewSmtpService";
import EditSmtpService from "../pages/systemAdmin/smtpService/EditSmtpService";


export default [
  //BRANCH
  {
    path: "/sya0200",
    component: ManageBranch,
    isProtected: true,
  },
  {
    path: "/add-sya0200",
    component: AddSYA0200,
    isProtected: true,
  },
  {
    path: "/view-sya0200",
    component: ViewSYA0200,
    isProtected: true,
  },
  {
    path: "/edit-sya0200",
    component: EditSYA0200,
    isProtected: true,
  },
  {
    path: "/import-sya0200",
    component: ImportSYA0200,
    isProtected: true,
  },

  //BRANCH TYPES
  {
    path: "/sya0300",
    component: SYA0300,
    isProtected: true,
  },
  {
    path: "/add-sya0300",
    component: AddSYA0300,
    isProtected: true,
  },
  {
    path: "/edit-sya0300",
    component: EditSYA0300,
    isProtected: true,
  },
  {
    path: "/view-sya0300",
    component: ViewSYA0300,
    isProtected: true,
  },

  //BRANCH CONFIGURATION
  {
    path: "/sya0400",
    component: ManageBranchConfiguration,
    isProtected: true,
  },
  {
    path: "/add-sya0400",
    component: NewBranchConfiguration,
    isProtected: true,
  },
  {
    path: "/view-sya0400",
    component: DetailBranchConfiguration,
    isProtected: true,
  },
  {
    path: "/edit-sya0400",
    component: EditBranchConfiguration,
    isProtected: true,
  },

  //BRANCH VAULT SETUP
  {
    path: "/sya0500",
    component: ManageBranchVault,
    isProtected: true,
  },
  {
    path: "/add-sya0500",
    component: NewSYA0500,
    isProtected: true,
  },
  {
    path: "/view-sya0500",
    component: DetailVaultConfig,
    isProtected: true,
  },
  {
    path: "/edit-sya0500",
    component: EditVaultConfiguration,
    isProtected: true,
  },

   //TILL CONFIGURATION
   {
    path: "/sya0600",
    component: ManageTillConfiguration,
    isProtected: true,
  },
  {
    path: "/add-sya0600",
    component: NewTillConfiguration,
    isProtected: true,
  },
  {
    path: "/view-sya0600",
    component: DetailTillConfiguration,
    isProtected: true,
  },
  {
    path: "/edit-sya0600",
    component: EditTillConfiguration,
    isProtected: true,
  },

  //HOLIDAY
  {
    path: "/sya0700",
    component: SYA0700,
    isProtected: true,
  },
  {
    path: "/add-sya0700",
    component: AddSYA0700,
    isProtected: true,
  },
  {
    path: "/view-sya0700",
    component: ViewSYA0700,
    isProtected: true,
  },
  {
    path: "/edit-sya0700",
    component: EditSYA0700,
    isProtected: true,
  },

  //ENTITY TABLES
  {
    path: "/sya0900",
    component: SYA0900,
    isProtected: true,
  },
  {
    path: "/add-sya0900",
    component: AddSYA0900,
    isProtected: true,
  },

  //WORKDAYS
  {
    path: "/sya0800",
    component: SYA0800,
    isProtected: true,
  },

  //PAYMENT TYPES
  {
    path: "/sya1100",
    component: SYA1100,
    isProtected: true,
  },
  {
    path: "/edit-sya1100",
    component: EditSYA1100,
    isProtected: true,
  },

  //USER DEFINED TABLES
  {
    path: "/sya1000",
    component: SYA1000,
    isProtected: true,
  },
  {
    path: "/add-sya1000",
    component: AddSYA1000,
    isProtected: true,
  },
  {
    path: "/view-sya1000",
    component: ViewSYA1000,
    isProtected: true,
  },
  {
    path: "/edit-sya1000",
    component: EditSYA1000,
    isProtected: true,
  },

  //CURRENCY
  {
    path: "/sya1300",
    component: SYA1300,
    isProtected: true,
  },
  {
    path: "/add-sya1300",
    component: AddSYA1300,
    isProtected: true,
  },
  {
    path: "/view-sya1300",
    component: ViewSYA1300,
    isProtected: true,
  },

  //CODE DEFINITION
  {
    path: "/sya1200",
    component: SYA1200,
    isProtected: true,
  },
  {
    path: "/add-sya1200",
    component: AddSYA1200,
    isProtected: true,
  },
  {
    path: "/view-sya1200",
    component: ViewSYA1200,
    isProtected: true,
  },
  {
    path: "/edit-sya1200",
    component: EditSYA1200,
    isProtected: true,
  },

  //SMS CAMPAIGN
  {
    path: "/sya1400",
    component: SYA1400,
    isProtected: true,
  },
  {
    path: "/add-sya1400",
    component: AddSYA1400,
    isProtected: true,
  },

  //SYSTEM HOOK
  {
    path: "/sya1500",
    component: SYA1500,
    isProtected: true,
  },
  {
    path: "/add-sya1500",
    component: AddSYA1500,
    isProtected: true,
  },
  {
    path: "/view-sya1500",
    component: ViewSYA1500,
    isProtected: true,
  },

  //BULK IMPORT
  {
    path: "/sya1600",
    component: SYA1600,
    isProtected: true,
  },

  //ENTITY MAPPING
  {
    path: "/sya1700",
    component: SYA1700,
    isProtected: true,
  },

  //GLOBAL CONFIGURATION
  {
    path: "/sya2100",
    component: SYA2100,
    isProtected: true,
  },
  {
    path: "/edit-sya2100",
    component: EditSYA2100,
    isProtected: true,
  },

  //CUSTOMER SURVEY
  {
    path: "/sya1800",
    component: SYA1800,
    isProtected: true,
  },
  {
    path: "/add-sya1800",
    component: AddSYA1800,
    isProtected: true,
  },
  {
    path: "/view-sya1800",
    component: ViewSYA1800,
    isProtected: true,
  },
  {
    path: "/edit-sya1800",
    component: EditSYA1800,
    isProtected: true,
  },

  //ADHOC QUERY SETUP
  {
    path: "/sya2200",
    component: SYA2200,
    isProtected: true,
  },
  {
    path: "/add-sya2200",
    component: AddSYA2200,
    isProtected: true,
  },
  {
    path: "/view-sya2200",
    component: ViewSYA2200,
    isProtected: true,
  },
  {
    path: "/edit-sya2200",
    component: EditSYA2200,
    isProtected: true,
  },

  //BATCH JOB OPERATIONS
  {
    path: "/sya2300",
    component: SYA2300,
    isProtected: true,
  },
  {
    path: "/view-sya2300",
    component: ViewSYA2300,
    isProtected: true,
  },
  {
    path: "/edit-sya2300",
    component: EditSYA2300,
    isProtected: true,
  },
  {
    path: "/add-sya2300",
    component: AddSYA2300,
    isProtected: true,
  },

  //BULK LOAN REASSIGNMENT
  {
    path: "/sya2400",
    component: SYA2400,
    isProtected: true,
  },

  //CLIENT CATEGORY
  {
    path: "/sya2500",
    component: SYA2500,
    isProtected: true,
  },
  {
    path: "/add-sya2500",
    component: AddSYA2500,
    isProtected: true,
  },
  {
    path: "/view-sya2500",
    component: ViewSYA2500,
    isProtected: true,
  },
  {
    path: "/edit-sya2500",
    component: EditSYA2500,
    isProtected: true,
  },

  //LIMIT RULE MAKER
  {
    path: "/sya2600",
    component: SYA2600,
    isProtected: true,
  },

  //ACCOUNT NUMBERING
  {
    path: "/sya0100",
    component: SYA0100,
    isProtected: true,
  },
  {
    path: "/add-sya0100",
    component: AddSYA0100,
    isProtected: true,
  },
  {
    path: "/view-sya0100",
    component: ViewSYA0100,
    isProtected: true,
  },
  {
    path: "/edit-sya0100",
    component: EditSYA0100,
    isProtected: true,
  },
  // NOTIFICATION SETUP

  {
    path: "/sya2700",
    component: ViewEmailService,
    isProtected: true,
  },
  {
    path: "/edit-sya2700",
    component: EditEmailService,
    isProtected: true,
  },
  {
    path: "/sya2800",
    component:ViewSmtpService,
    isProtected: true,
  },
  {
    path: "/edit-sya2800",
    component:EditSmtpService,
    isProtected: true,
  },
];
